var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 6,
    viewBox: "0 0 9 6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4.438L1.278.756l-.556.488L4.5 5.562l3.778-4.318-.556-.488z"
  })));
}

export default __webpack_public_path__ + "189b685dda0f4dc988bc0b08d68c35be.svg";
export { SvgChevronDown as ReactComponent };